import { useMemo } from 'react';

import getVariantSkuForSelectedOptionsExtended from 'components/consumer/PDP/state/helpers/getVariantSkuForSelectedOptionsExtended';
import usePdpLastHoveredOptionsExtended from '../pdpLastHoveredOptionsExtended/usePdpLastHoveredOptionsExtended';
import usePdpOptionsOrder from '../pdpOptionsOrder/usePdpOptionsOrder';

// This state is derived from other PDP state, so there is no hook to set it
const usePdpLastHoveredVariantSku = () => {
  const pdpLastHoveredOptionsExtended = usePdpLastHoveredOptionsExtended();
  const pdpOptionsOrder = usePdpOptionsOrder();

  const pdpLastHoveredVariantSku = useMemo(
    () =>
      getVariantSkuForSelectedOptionsExtended(
        pdpLastHoveredOptionsExtended,
        pdpOptionsOrder
      ) || null,
    [pdpLastHoveredOptionsExtended, pdpOptionsOrder]
  );

  return pdpLastHoveredVariantSku;
};

export default usePdpLastHoveredVariantSku;
